import 'vuetify/styles'
import './styles/glightbox.css'
import 'vanilla-cookieconsent/dist/cookieconsent.js'
// @ts-ignore
import GLightbox from 'glightbox'

export const app = {
  mounted () {
    this.$nextTick(() => {
      const lightbox = GLightbox({
        selector: '.glightbox'
      })

      // @ts-expect-error global window
      const cc = initCookieConsent()

      // run plugin with your configuration
      cc.run({
        gui_options: {
          consent_modal: {
            layout: 'box', // box/cloud/bar
            position: 'bottom right', // bottom/middle/top + left/right/center
            transition: 'slide', // zoom/slide
            swap_buttons: false // enable to invert buttons
          },
          settings_modal: {
            layout: 'box', // box/bar
            // position: 'left',           // left/right
            transition: 'slide' // zoom/slide
          }
        },
        current_lang: window.document.documentElement.lang,
        languages: {
          cs: {
            consent_modal: {
              title: 'Souhlas s používáním cookies',
              description:
                'Tento web a partneři potřebují Váš souhlas s použitím souborů cookies, aby Vám mohli zobrazovat informace v souladu s Vašimi zájmy. <button type="button" data-cc="c-settings" class="cc-link">Nastavit podrobně.</button>',
              primary_btn: {
                text: 'Příjmout všechny',
                role: 'accept_all'
              },
              secondary_btn: {
                text: 'Příjmout povinné',
                role: 'accept_necessary'
              }
            },
            settings_modal: {
              title: 'Nastavení cookies',
              save_settings_btn: 'Uložit nastavení',
              accept_all_btn: 'Přimout všechny',
              reject_all_btn: 'Odmítnout všechny',
              close_btn_label: 'Zavřít',
              cookie_table_headers: [
                { col1: 'Název' },
                { col2: 'Doména' },
                { col3: 'Expirace' },
                { col4: 'Popis' }
              ],
              blocks: [
                {
                  title: 'Souhlas s používáním cookies',
                  description:
                    'Zde máte možnost přizpůsobit soubory cookie podle kategorií, v souladu s vlastními preferencemi.'
                },
                {
                  title: 'Nezbytné cookies',
                  description:
                    'Tyto cookies nám pomáhají zajistit základní funkce, jako je zajištění funkčnosti a bezpečného chodu webové stránky, přístup k zabezpečeným částem webové stránky, rychlé načítání webového obsahu, ověření uživatele nebo zaznamenání, zda jste nám udělili souhlas dle tohoto dokumentu, včetně uložení uživatelských preferencí na doméně během relace. Takové cookies jsou nezbytné pro fungování našeho webu, a proto k jejich ukládání a čtení nepotřebujeme váš souhlas.',
                  toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true
                  }
                },
                {
                  title: 'Pokročilé analytické funkce',
                  description:
                    'Na základě vašeho souhlasu používáme cookies, které slouží k vytváření statistik, sledování a analýze chování uživatelů na webové stránce. Data nám pomáhají určit oblíbenost jednotlivých stránek funkcí a slouží jako podklad pro zlepšování webové stránky.',
                  toggle: {
                    value: 'analytics',
                    enabled: false,
                    readonly: false
                  },
                  cookie_table: [
                    {
                      col1: '^_ga',
                      col2: 'google.com',
                      col3: '13 měsíců',
                      col4: 'Google Analytics – sledování stavu a výkonu účtu, shrnutí návštěvnosti, aktivní uživatelé, průzkumník uživatelů, analytika uživatelů, pravděpodobnost konverze, srovnávací zprávy, demografické údaje a zájmy, přehled toku uživatelů, přehledy AdWords; Chcete-li se odhlásit ze sledování službou Google Analytics na všech webových stránkách, navštivte prosím: https://tools.google.com/dlpage/gaoptout. Podrobné informace o Google Analytics a ochraně osobních údajů naleznete na adrese: https://policies.google.com/privacy?hl=cs.',
                      is_regex: true
                    }
                  ]
                },
                {
                  title: 'Více informací',
                  description:
                    'Pro dotazy ohledně zpracování osobních údajů kontaktujte <a class="cc-link" href="mailto:info@thaimost.cz">pověřence na ochranu osobních údajů</a>.'
                }
              ]
            }
          },
          en: {
            consent_modal: {
              title: 'Consent to the use of cookies',
              description:
                'This website and its partners need your consent to use cookies to show you information in line with your interests. <button type="button" data-cc="c-settings" class="cc-link">Set in detail.</button>',
              primary_btn: {
                text: 'Accept all',
                role: 'accept_all'
              },
              secondary_btn: {
                text: 'Accept mandatory',
                role: 'accept_necessary'
              }
            },
            settings_modal: {
              title: 'Cookies settings',
              save_settings_btn: 'Save settings',
              accept_all_btn: 'Accept all',
              reject_all_btn: 'Reject all',
              close_btn_label: 'Close',
              cookie_table_headers: [
                { col1: 'Name' },
                { col2: 'Domain' },
                { col3: 'Expiration' },
                { col4: 'Description' }
              ],
              blocks: [
                {
                  title: 'Consent to the use of cookies',
                  description:
                    'Here you have the option to customize cookies by category, in accordance with your own preferences.'
                },
                {
                  title: 'Necessary cookies',
                  description:
                    'These cookies help us to provide essential functions such as ensuring the functionality and safe operation of the website, accessing secure parts of the website, loading web content quickly, authenticating the user or recording whether you have given us consent under this document, including storing user preferences on the domain during the session. Such cookies are necessary for the operation of our website and therefore we do not need your consent to store and read them.',
                  toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true
                  }
                },
                {
                  title: 'Advanced analytical functions',
                  description:
                    'Based on your consent, we use cookies to generate statistics, track and analyse user behaviour on the website. The data helps us to determine the popularity of individual page features and serves as a basis for improving the website.',
                  toggle: {
                    value: 'analytics',
                    enabled: false,
                    readonly: false
                  },
                  cookie_table: [
                    {
                      col1: '^_ga',
                      col2: 'google.com',
                      col3: '13 months',
                      col4: 'Google Analytics - account status and performance tracking, traffic summaries, active users, user explorer, user analytics, conversion probability, benchmarking reports, demographics and interests, user flow overview, AdWords reports; To opt-out of Google Analytics tracking on all websites, please visit: https://tools.google.com/dlpage/gaoptout. For more information about Google Analytics and privacy, please visit: https://policies.google.com/privacy?hl=en.',
                      is_regex: true
                    }
                  ]
                },
                {
                  title: 'More information',
                  description:
                    'For questions about the processing of personal data, please contact the <a class="cc-link" href="mailto:info@thaimost.cz">Data Protection Officer</a>.'
                }
              ]
            }
          }
        }
      })
    })
  },
  components: {

  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    toggleMainMenu () {
      this.menu = !this.menu
    }
  }
}
